import { html, TemplateResult } from 'lit';
import { msg } from '@lit/localize';
import type { RoundtripOfferViewModel } from '../types/offer.types';

export interface PriceBoxFixedTemplateOptions {
    price: string;
    bestOffer?: RoundtripOfferViewModel | null;
    onButtonClick: (event: PointerEvent) => void;
    loading?: boolean;
}

export function renderPriceBoxFixed(options: PriceBoxFixedTemplateOptions, lang?: string): TemplateResult {
    return html`
        <div class="m-price-box fixed ${lang === 'fr-CH' ? 'm-price-box--fr' : ''}">
            <div class="m-price-box__price">
                <div class="m-price-box__amount">
                    <span class="m-price-box__label">${msg('fromPrice')}</span>
                    ${options.loading
                        ? html`<b class="der-tm-offer-panel-skeleton-line der-tm-offer-panel-skeleton-line--w-5"></b>`
                        : options.price}
                </div>
                <div class="m-price-box__per-person">${msg('perPersonLabel')}</div>
            </div>
            <div class="m-price-box__button">
                <der-ui-button @click=${options.onButtonClick}>${msg('ctaText')}</der-ui-button>
            </div>
        </div>
    `;
}
